import { useEffect, useState } from "react";

const hashPath = () => window.location.hash.replace(/^#\/?/, "").split("?")[0]!;

/** Hash changes as React state. */
function useHash(): string {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return hash;
}

/** Route from the hash: `#/reservas/<id>?q=…` → ["reservas", "<id>"]. */
export function useRoute(): string[] {
  useHash();
  return hashPath().split("/").filter(Boolean).map(decodeURIComponent);
}

/** Parameters after the `?` in the hash, for screens that keep their filters in the address. */
export function useHashParams(): URLSearchParams {
  const hash = useHash();
  return new URLSearchParams(hash.split("?")[1] ?? "");
}

export function go(...parts: string[]) {
  window.location.hash = `#/${parts.map(encodeURIComponent).join("/")}`;
}

/** Like `go`, with parameters; `replace` adds no history entry (e.g. while typing). */
export function goWith(parts: string[], params: URLSearchParams, { replace = false } = {}) {
  const query = params.toString();
  const hash = `#/${parts.map(encodeURIComponent).join("/")}${query ? `?${query}` : ""}`;
  if (hash === window.location.hash) return;
  if (replace) {
    history.replaceState(null, "", hash);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    window.location.hash = hash;
  }
}
